<template>
  <div>
    <vx-card style="padding: 0px">
      <form-wizard
        :title="null"
        :subtitle="null"
        finishButtonText="Tamam"
        @on-complete="stokTransfer"
        nextButtonText="Sonraki"
        backButtonText="Önceki"
        color="rgba(var(--vs-primary), 1)"
        errorColor="rgba(var(--vs-danger), 1)"
        :start-index="startIndexValue"
      >
        <tab-content
          title="Fatura"
          class="mb-5"
          icon="feather icon-map"
          :before-change="validateStep1"
          style="padding: 0px !important"
        >
          <form data-vv-scope="step-1">
            <b-row style="padding: 15px">
              <div
                ref="form"
                class="repeater-form"
                @submit.prevent="repeateAgain"
              >
                <!-- Row Loop -->
                <b-form ref="form" @submit.prevent="repeateAgain">
                  <b-row>
                    <b-col cols="12"> </b-col>
                    <b-col cols="12"> </b-col>

                    <b-col cols="12">
                      <b-row>
                        <b-col cols="3">
                          <p style="text-align: center">Ürün</p>
                        </b-col>
                        <b-col cols="1">
                          <p style="text-align: center">Grup Kod</p>
                        </b-col>
                        <b-col cols="1">
                          <p style="text-align: center">Özel Kod 1</p>
                        </b-col>
                        <b-col cols="1">
                          <p style="text-align: center">Özel Kod 2</p>
                        </b-col>
                        <b-col cols="1">
                          <p style="text-align: center">Giriş Adet</p>
                        </b-col>
                        <b-col cols="1">
                          <p style="text-align: center">Fiyat</p>
                        </b-col>
                        <b-col cols="1">
                          <p style="text-align: center">Tutar</p>
                        </b-col>

                        <b-col cols="1"> </b-col>
                      </b-row>
                    </b-col>

                    <b-col cols="12">
                      <div :class="scrollview" style="padding-right: 10px;">
                        <b-row
                          v-for="(item, index) in items"
                          :id="item.id"
                          :key="item.id"
                          ref="row"
                        >
                          <!-- Item Name -->

                          <b-col cols="5">
                            <b-form-group label-for="cost">
                              <v-select
                                v-model="item.TRANSSTOCKNAME"
                                :options="stokListesi"
                                label="STOCKNAME"
                                autocomplete
                                size="small"
                                :disabled="item.disabled"
                              >
                              </v-select>
                            </b-form-group>
                          </b-col>

                          <b-col cols="2" style="padding-right: 0">
                            <b-form-group label-for="cost">
                              <v-select
                                v-model="item.TRANSGROUPCODE"
                                :options="ANAUNITOPTION"
                                label="DESCRIPTION"
                                autocomplete
                                size="small"
                                :disabled="item.disabled"
                              >
                              </v-select>
                            </b-form-group>
                          </b-col>
                          <b-col cols="2" style="padding-right: 0">
                            <v-select
                              v-model="item.TRANSSPECCODE1"
                              :options="ANADEPOOPTION"
                              label="DESCRIPTION"
                              autocomplete
                              size="small"
                              :disabled="item.disabled"
                            >
                            </v-select>
                          </b-col>
                          <b-col cols="1" style="padding-right: 0">
                            <b-form-group label-for="cost">
                              <b-form-input
                                v-model="item.TRANSSPECCODE2"
                                style="font-size: inherit"
                                id="cost"
                                type="text"
                                placeholder="Adet 1"
                                :disabled="item.disabled"
                              />
                            </b-form-group>
                          </b-col>

                          <b-col cols="1" style="padding-right: 0">
                            <b-form-group label-for="cost">
                              <b-form-input
                                v-model="item.TRANSQENTRY"
                                style="font-size: inherit"
                                id="cost"
                                type="text"
                                placeholder="Adet 2"
                                :disabled="item.disabled"
                              />
                            </b-form-group>
                          </b-col>
                          <b-col cols="1" style="padding-right: 0">
                            <b-form-group label-for="cost">
                              <b-form-input
                                v-model="item.TRANSPRICE"
                                style="font-size: inherit"
                                id="cost"
                                type="text"
                                placeholder="Adet 2"
                                :disabled="item.disabled"
                              />
                            </b-form-group>
                          </b-col>
                          <b-col cols="1" style="padding-right: 0">
                            <b-form-group label-for="cost">
                              <b-form-input
                                v-model="item.TRANSTOTAL"
                                style="font-size: inherit"
                                id="cost"
                                type="text"
                                placeholder="Adet 2"
                                :disabled="item.disabled"
                              />
                            </b-form-group>
                          </b-col>
                          <!-- Quantity -->

                          <b-col
                            style="padding-right: 0"
                            cols="1"
                            class="mb-50"
                            v-if="item.disabled == false"
                          >
                            <b-row style="padding: 0">
                              <b-col style="padding: 0">
                                <b-button
                                  variant="outline-light"
                                  size="sm"
                                  v-on:click="addRecete(index)"
                                >
                                  <Icon
                                    color="#28c76f"
                                    icon="ic:baseline-save-all"
                                    width="20"
                                    height="20"
                                  />
                                </b-button>
                              </b-col>
                            </b-row>
                          </b-col>

                          <b-col cols="1" class="mb-50" v-else>
                            <b-row style="padding: 0">
                              <b-col style="padding: 0">
                                <b-button
                                  variant="outline-light"
                                  size="sm"
                                  v-on:click="removeRecete(index)"
                                >
                                  <Icon
                                    color="#EA5455"
                                    icon="ic:baseline-remove-circle"
                                    width="20"
                                    height="20"
                                  />
                                </b-button>
                              </b-col>
                            </b-row>
                          </b-col>
                          <!-- Remove Button -->
                          <b-col cols="12" style="height: 5px"> </b-col>
                        </b-row>
                      </div>
                    </b-col>
                  </b-row>
                  <!-- Row Loop -->
                </b-form>
              </div>
            </b-row>
          </form>
        </tab-content>

        <!-- tab 2 content -->
        <tab-content class="mb-5" icon="feather icon-file-text">
          <!-- tab 1 content -->
          <form data-vv-scope="step-1">
            <b-row style="padding: 15px"> </b-row>
          </form>
        </tab-content>
        <!-- tab 3 content -->
      </form-wizard>
    </vx-card>
  </div>
</template>
<script>
import state from "../../store/state";
import Store from "../../store/store";
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import { Validator } from "vee-validate";
const dict = {
  custom: {
    stock_name: {
      required: "Stok Adı gereklidir",
      alpha: "Stok Adı gereklidir"
    },
    stok_kodu: {
      required: "Stok Kodu gereklidir",
      alpha: "Stok Kodu gereklidir"
    }
  }
};

// register custom messages
Validator.localize("en", dict);
export default {
  components: {
    FormWizard,
    TabContent
  },
  data() {
    return {
      itemIndex: 1,
      startIndexValue: 0,
      scrollview: "",
      stokListInput: "",
      items: [
        {
          id: 1,
          TRANSSTOCKNAME: "",
          TRANSSTOKID: "",
          TRANSDATE: "",
          TRANSTYPE: "",
          TRANSDESCRIPTION: "",
          TRANSGROUPCODE: "",
          TRANSSPECCODE1: "",
          TRANSSPECCODE2: "",
          TRANSCODE: "",
          TRANSDEPOTID: "",
          TRANSQENTRY: "",
          TRANSQEXIT: "",
          TRANSPRICE: "",
          TRANSCURRPRICE: "",
          TRANSTOTAL: "",
          disabled: false
        }
      ]
    };
  },
  created() {
    this.scrollview = "scroll-hand";
    this.getStokList();
  },
  methods: {
    repeateAgain() {
      this.itemIndex++;
      this.items.push({
        id: this.itemIndex,
        disabled: false
      });
    },
    getStokList() {
      let type = "material";

      var vm = this;
      var vs = this.$vs;

      vm.veriler = [];
      const soap = require("soap");
      let url = state.sistemAddress;
      url = url.replace("sistem", "uzumMrp");
      const args = {
        COMPANYID: state.MusteriId,
        ARANAN: vm.stokListInput,
        ISLEM: "LIST",
        token: Store.state.tokenId
      };
      soap.createClient(url, function(err, client) {
        client.STOCK(args, function(err, result) {
          if (result.STOCKResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          vm.veriler = JSON.parse(result.STOCKResult);
          vs.loading.close();
          vs.loading.close("#loading-material-1 > .con-vs-loading");
          vm.stokListesi = JSON.parse(vm.veriler.jsonData);
        });
      });
    },

    validateStep1() {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll("step-1").then(result => {
          if (result) {
            resolve(true);
          } else {
            reject("correct all values");
          }
        });
      });
    },
    stokTransfer() {}
  }
};
</script>
<style lang="scss">
.scroll-hand {
  min-height: 250px;
  max-height: 250px;
  overflow-y: auto;
  overflow-x: hidden;
}

[dir] .vue-form-wizard .wizard-tab-content {
  padding: 0px !important;
}

[dir] .vue-form-wizard .wizard-header {
  padding: 0px !important;
}
</style>
